import { Action } from '@ngrx/store';
import { NextWorkingDayResponseV5 } from '@cemex-core/cmx-api/models/next-working-day/next-working-day-res';

export enum CutOffTemperatureActionTypes {
  LOAD = '[Rms Cut off Temperature] Load cut off',
  RESET = '[Rms Cut off Temperature] Reset',
  CHANGE_FLAG_FORM = '[Rms Cut off Temperature] Change flag form',
}

export class CutOffTemperatureLoadAction implements Action {
  readonly type = CutOffTemperatureActionTypes.LOAD;

  constructor(
    public payload: NextWorkingDayResponseV5,
    public formId: string,
  ) {}
}

export class CutOffTemperatureResetAction implements Action {
  readonly type = CutOffTemperatureActionTypes.RESET;

  constructor() {}
}
export class CutOffTemperatureChangeFlagAction implements Action {
  readonly type = CutOffTemperatureActionTypes.CHANGE_FLAG_FORM;

  constructor(public formId: string) {}
}

export type CutOffTemperatureActions =
  | CutOffTemperatureLoadAction
  | CutOffTemperatureResetAction
  | CutOffTemperatureChangeFlagAction;
